import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FunctionComponent } from 'react';

type PlayButtonProps = {
    className?: string;
};

const PlayButton: FunctionComponent<PlayButtonProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'play-button'}
            viewBox="0 0 100 100"
        >
            <path d="M50 100C22.386 100 0 77.614 0 50S22.386 0 50 0s50 22.386 50 50-22.386 50-50 50zm0-4c25.405 0 46-20.595 46-46S75.405 4 50 4 4 24.595 4 50s20.595 46 46 46zm27-46L35 75V25l42 25z" />
        </svg>
    );
};
export default PlayButton;
